@if (vm$ | async; as vm) {
    <div>
        @switch (side) {
            @default {
                <div class="page-consent">
                    <h1 class="mat-dialog-title">Du bestemmer over dine data</h1>
                    <mat-dialog-content>
                        <p>
                            Vi bruger nødvendige cookies til at få ServicePro til at fungere. Vi vil derudover gerne bruge valgfrie cookies til at huske
                            dine præferencer (fx senest valgte værk og filtervalg på oversigtskort).
                        </p>
                        <p>
                            Vi placerer først de valgfrie cookies, hvis du har givet os dit samtykke nedenfor. Ved at klikke på ”Tillad alle cookies” samtykker du til de
                            valgfrie cookies. Du kan til enhver tid trække dit samtykke tilbage eller ændre dit samtykke ved at klikke på cookie-ikonet øverst til højre i
                            ServicePro. Du skal være opmærksom på, at ServicePro muligvis ikke fungerer optimalt, hvis du ikke accepterer cookies.
                        </p>
                    </mat-dialog-content>
                    <mat-dialog-actions>
                        <div>
                            <a class="read-more" href="#" (click)="onGotoReadMoreClick($event)">Læs mere...</a>
                        </div>
                        <div>
                            <button
                                mat-flat-button
                                color="primary"
                                [mat-dialog-close]
                                (click)="onConsentApproveClick()"
                                data-testid="cookiepolicy-accept"
                                data-cookiescanner="cookiepolicy-accept"
                            >
                                TILLAD ALLE COOKIES
                            </button>
                            <button
                                mat-stroked-button
                                color="primary"
                                [mat-dialog-close]
                                (click)="onConsentRejectClick()"
                                data-testid="cookiepolicy-reject"
                                data-cookiescanner="cookiepolicy-reject"
                            >
                                KUN NØDVENDIGE COOKIES
                            </button>
                        </div>
                    </mat-dialog-actions>
                </div>
            }
            @case ("laes-mere") {
                <div class="page-laes-mere">
                    <h1 class="mat-dialog-title">
                        <a href="#" class="back" aria-label="Tilbage" (click)="onGotoConsentClick($event)"
                            ><mat-icon svgIcon="service-pro-cookie-consent.arrow-left"></mat-icon
                        ></a>
                        <span>Information om cookies</span>
                    </h1>
                    <mat-dialog-content>
                        <mat-tab-group class="button-toggle">
                            <mat-tab label="Cookiepolitik">
                                @if (vm.policyHtml) {
                                    <div [innerHTML]="vm.policyHtml"></div>
                                } @else {
                                    <p>Cookiepolitik er ikke tilgængelig endnu. Vælg værk for at hente den fulde tekst.</p>
                                }
                            </mat-tab>
                            <mat-tab label="Cookies">
                                <div>
                                    @if (vm.cookies.mandatory.length) {
                                        <h3>Nødvendige cookies</h3>
                                        <dff-cookie-consent-cookie-list [cookies]="vm.cookies.mandatory"></dff-cookie-consent-cookie-list>
                                    }
                                    @if (vm.cookies.optional.length) {
                                        <h3>Valgfri cookies</h3>
                                        <dff-cookie-consent-cookie-list [cookies]="vm.cookies.optional"></dff-cookie-consent-cookie-list>
                                    }
                                </div>
                            </mat-tab>
                        </mat-tab-group>
                    </mat-dialog-content>
                </div>
            }
        }
    </div>
} @else {
    <div class="spinner-container">
        <mat-spinner></mat-spinner>
    </div>
}
